import PropTypes from 'prop-types'
import classNames from "classnames";
import Icon from "common/components/elements/icons";

const infosList = [
   {
      icon: 'paper-shredder',
      text: 'We do NOT store ANY personal information during this process',
   },
   {
      icon: 'protected',
      text: 'This process is carried out by trusted service providers who focus on confirming the age of online users',
   },
   {
      icon: 'visibility-lock',
      text: "This age verification does NOT allow anyone to track your online activity",
   },
]

const AgeVerificationInfoList = ({
   isMobile,
   isIconsPrimaryColor,
}) => {

   return (
      <div
         className={ classNames({
            'flex gap-4 w-full': true,
            'flex-col': isMobile,
         }) }
      >
         {
            infosList.map((item, idx) => (
               <div
                  key={ idx }
                  className={ classNames({
                     'w-full bg-grey-main dark:bg-[#000] p-4 flex flex-col items-center gap-3 rounded-lg': true,
                     // 'max-w-[256px]': !isMobile,
                  }) }
               >
                  <Icon
                     name={ item.icon }
                     size='2xl'
                     color='action'
                     darkColor='action-dark'
                     className={ isIconsPrimaryColor ? 'skin-primary-text' : '' }
                  />
                  <span
                     className='text-center text-major dark:text-major-dark text-sm'
                  >
                     {item.text}
                  </span>
               </div>
            ))
         }
      </div>
   )
}

AgeVerificationInfoList.propTypes = {
   isMobile: PropTypes.bool,
   isIconsPrimaryColor: PropTypes.bool,
}

export default AgeVerificationInfoList;
